/*Ingredient List section*/
document.body.addEventListener("click", function(event) {
	const clicked = event.target.closest(".ingredient-list--item:not(.active)");
	if (!clicked) {
		return; // Exit if click is not on the correct element
	}
	
	const parent = clicked.closest(".ingredient-list--wrapper");
	const clickedIndex = parseInt(clicked.dataset.index, 10);
	
	// Remove 'active' class from currently active items
	parent.querySelectorAll(".ingredient-list--item.active, .ingredient-list--item-detail.active").forEach(el => el.classList.remove("active"));
	
	// Add 'active' class to the clicked item and corresponding detail
	parent.querySelectorAll(`.ingredient-list--item[data-index="${clickedIndex}"], .ingredient-list--item-detail[data-index="${clickedIndex}"]`).forEach(el => el.classList.add("active"));
	
	const scrollParent = parent.querySelector( '.ingredient-list--item-detail.active' );
	
	// Smooth scroll if window width is <= 960px
	if (window.innerWidth <= 960) {
		window.scrollTo({
			top: scrollParent.getBoundingClientRect().top + window.scrollY - 120,
			behavior: "smooth"
		});
	}
});

/*Product Navbar Section*/
document.querySelectorAll('.product-nav-bar--btn').forEach(button => {
	button.addEventListener('click', function () {
	  const targetClass = this.getAttribute('data-scroll-target');
	  const targetElement = document.querySelector(targetClass);
  
	  if (targetElement) {
		let offset = window.innerWidth <= 767 ? 87 : 159; // Adjust offset based on screen width
		const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
		  window.scrollTo({
			top: elementPosition - offset,
			behavior: 'smooth'
		  });
		}
	});
});


/*Product Popup buttons*//*
document.querySelectorAll('.popup-buttons--btn').forEach((button, index) => {
    button.addEventListener('click', () => {
      const popupContainer = document.querySelectorAll('.popup-container')[index];
      const overlay = document.querySelector('.popup--overlay'); 
  
      popupContainer.style.display = 'flex';
      overlay.style.display = 'block';
  
      setTimeout(() => {
        popupContainer.classList.add('show');
        overlay.classList.add('show');
      }, 10); 
  
      overlay.addEventListener('click', () => {
        popupContainer.classList.remove('show');
        overlay.classList.remove('show');
  
        setTimeout(() => {
          popupContainer.style.display = 'none';
          overlay.style.display = 'none';
        }, 300);
      });
  
      const closeButton = popupContainer.querySelector('.popup-close-btn');
      closeButton.addEventListener('click', () => {
        popupContainer.classList.remove('show');
        overlay.classList.remove('show');
  
        setTimeout(() => {
          popupContainer.style.display = 'none';
          overlay.style.display = 'none';
        }, 300); 
      });
    });
  });
  */


/*Product Popup buttons*/
  document.querySelectorAll('.popup-buttons--btn').forEach((button, index) => {
	button.addEventListener('click', () => {
	  const popupContainer = document.querySelectorAll('.popup-container')[index];
	  
	  let overlay = document.querySelector('.popup--overlay');
	  if (!overlay) {
		overlay = document.createElement('div');
		overlay.className = 'popup--overlay';
		document.body.appendChild(overlay);
	  }
  
	  popupContainer.style.display = 'flex';
	  overlay.style.display = 'block';
  
	  setTimeout(() => {
		popupContainer.classList.add('show');
		overlay.classList.add('show');
	  }, 10);
  
	  overlay.onclick = () => closePopup(popupContainer, overlay);
  
	  const closeButton = popupContainer.querySelector('.popup-close-btn');
	  closeButton.onclick = () => closePopup(popupContainer, overlay);
	});
  });
  
  function closePopup(popup, overlay) {
	popup.classList.remove('show');
	overlay.classList.remove('show');
  
	setTimeout(() => {
	  popup.style.display = 'none';
	  overlay.style.display = 'none';
	}, 300);
  }
  



/*Make search for products and articles*/
  document.addEventListener("DOMContentLoaded", function () {
  const searchElement = document.querySelector("predictive-search-element");
  if (!searchElement) return;

  const originalGetSearchResults = searchElement.getSearchResults.bind(searchElement);

  searchElement.getSearchResults = async function (query) {
    this.abort_controller && this.abort_controller.abort();
    const trimmedQuery = query.trim();
    if (this.cached_results[trimmedQuery]) {
      this.results.innerHTML = this.cached_results[trimmedQuery];
    } else {
      this.abort_controller = new AbortController();
      this.toggleLoading(true);
      try {
        const response = await fetch(
          `${Shopify.routes.predictive_search}?q=${encodeURIComponent(trimmedQuery)}&resources[type]=product,article&section_id=predictive-search`,
          { signal: this.abort_controller.signal }
        );
        if (!response.ok) throw new Error(response.status);
        const html = (await response.text()).parse().innerHTML;
        this.cached_results[trimmedQuery] = html;
        this.results.innerHTML = html;
      } catch (error) {
        console.error("Predictive search fetch failed", error);
      }
    }
  };
});
 
/* Search page to show articles and products*/
document.addEventListener("DOMContentLoaded", function () {
  const searchEl = document.querySelector("predictive-search-element");
  if (!searchEl) return;

  const form = searchEl.querySelector("form");
  const input = searchEl.querySelector(".search--textbox");

  if (!form || !input) return;

  form.onsubmit = null;

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    const query = input.value.trim();
    if (query === "") return;

    window.location.href = `/search?q=${encodeURIComponent(query)}&type=product,article`;
  });
}); 

/* This is in theme.js -- DELETE AFTER

customElements.define("placeholder-element", Placeholder);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.form = this.querySelector("form")),
      (this.clear_button = this.querySelector(".search--clear")),
      (this.input = this.querySelector(".search--textbox")),
      (this.results = this.querySelector(".search--results")),
      (this.cached_results = { "": this.results.innerHTML }),
      this.listenForKeyEntered(),
      this.formSubmit(),
      this.clearButtonListener(),
      this.addMutationObserver();
  }
  listenForKeyEntered() {
    this.input.on("input", () => {
      var t = this.input.value.trim();
      (this.clear_button.style.display = "" === t ? "none" : "flex"),
        this.getSearchResults(t);
    });
  }
  async getSearchResults(t) {
    this.abort_controller && this.abort_controller.abort();
    var e = t.trim();
    if (this.cached_results[e]) this.results.innerHTML = this.cached_results[e];
    else {
      (this.abort_controller = new AbortController()), this.toggleLoading(!0);
      try {
        var i = await fetch(
          `${Shopify.routes.predictive_search}?q=${encodeURIComponent(
            t
          )}&section_id=predictive-search`,
          { signal: this.abort_controller.signal }
        );
        if (!i.ok) throw new Error(i.status);
        var s = (await i.text()).parse().innerHTML;
        (this.cached_results[e] = s), (this.results.innerHTML = s);
      } catch {}
    }
  }
  clearButtonListener() {
    this.clear_button.on("click keydown", (t) => {
      ("keydown" === t.type && "Enter" !== t.key) ||
        (t.preventDefault(),
        (this.input.value = ""),
        this.input.focus(),
        this.input.trigger("input"));
    });
  }
  toggleLoading(t) {
    setTimeout(() => this.setAttribute("data-loading", t), t ? 0 : 100);
  }
  formSubmit() {
    this.form.on("submit", (t) => {
      t.preventDefault(),
        (window.location.href =
          Shopify.routes.search +
          "?type=product&q=" +
          encodeURIComponent(this.input.value.trim()));
    });
  }
  addMutationObserver() {
    new MutationObserver(() => {
      this.toggleLoading(!1),
        window.trigger("theme:search:reloaded"),
        Transitions.reload("search");
    }).observe(this.results, { childList: !0 });
  }
}
customElements.define("predictive-search-element", PredictiveSearch);


*/

(function () {
  const BTN_SELECTOR = '.gPreorderBtn.gPreorderBtnLoaded';
  const FORM_SELECTOR = 'form[action*="/cart/add"]';
  const PROP_NAME = 'properties[_is_preorder]';
  const PROP_VALUE = 'true';

  function upsertHidden(form) {
    if (!form) return;
    if (!form.querySelector(`input[name="${CSS.escape(PROP_NAME)}"]`)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROP_NAME;
      input.value = PROP_VALUE;
      form.appendChild(input);
    }
  }

  function injectForButton(btn) {
    const form = btn.closest(FORM_SELECTOR) || btn.closest('form') || document.querySelector(FORM_SELECTOR);
    upsertHidden(form);
  }

  // Initial pass
  document.querySelectorAll(BTN_SELECTOR).forEach(injectForButton);

  // Catch dynamic changes (Globo / section reloads)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.target.matches?.(BTN_SELECTOR)) {
        injectForButton(m.target);
      }
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.(BTN_SELECTOR)) injectForButton(node);
        node.querySelectorAll?.(BTN_SELECTOR).forEach(injectForButton);
      });
    }
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();